import { Component, Input, OnChanges, OnInit, Output } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { FormlyFieldConfig } from '@ngx-formly/core'
import { BehaviorSubject, Subject } from 'rxjs'
import { LoadingState } from 'src/app/types/loading-state'

@Component({
    selector: 'app-form-master',
    templateUrl: './form-master.component.html',
    styleUrls: ['./form-master.component.scss'],
    standalone: false
})

/**
 * @descripton a form wrapper that contains the state of a form instance
 * @todo add disabled form state
 * @todo add unsavedChanges form state
 * @todo check if user canSave
 */
export class FormMasterComponent implements OnInit, OnChanges {
    public showContent = false
    public form = new FormGroup({})

    @Input() canDelete = false
    @Input() loading = false
    @Input() model = {}
    @Input() fields: FormlyFieldConfig[] = []
    @Input() loadingState: LoadingState = LoadingState.Initial
    @Input() submitText = 'Submit'
    @Input() discardText = 'Discard'
    @Input() unsavedText = 'Unsaved Changes.'
    @Input() deleteText = 'Delete'

    @Output() submitForm = new Subject()
    @Output() clearForm = new Subject()
    @Output() deleteForm = new Subject()
    @Output() unsavedForm = new BehaviorSubject(false)
    @Output() updatedModel = new BehaviorSubject(undefined)

    unsavedChanges = false
    canSave = false

    constructor() {}

    ngOnInit() {
        this.unsavedForm.next(this.unsavedChanges)
    }

    /**
     * @descripton check if the form has loaded
     */
    ngOnChanges() {
        this.showContent = this.loadingState === LoadingState.Loaded
    }

    public patchModel(key, value) {
        this.form.get(key).patchValue(value)
    }
    public replaceModel(newModel) {
        this.model = newModel
    }

    /**
     * @descripton check if the form has loaded, update the form state and emit the updated model
     */
    onModelChange() {
        this.unsavedChanges = true
        this.unsavedForm.next(this.unsavedChanges)
        this.updatedModel.next(this.model)
    }

    /**
     * @descripton empty the model and emit the new model
     */
    onCancelClick() {
        this.model = {}
        this.clearForm.next(this.model)
    }

    onDeleteClick() {
        this.deleteForm.next(true)
    }

    /**
     *
     * @param model emit the model to a subscriber in the main applcation that will handle the api request
     */
    onSubmit() {
        this.submitForm.next(this.model)
    }
}
